<select #comboBox
  [(ngModel)]="selectedCoopCode" [disabled]="disabled" [hidden]="!visible"
  (change)="updateBindedField($event);onChange($any($event.target).value);" (blur)="onTouched()"
  (focus)="focus.emit($event)" [class.combo-box-required]="required"
  [style.width.px]="width" [style.width]="width !== undefined ? width : '100%'" [tabindex]="tabindex">
  <ng-template ngFor let-item [ngForOf]="model.coopList">
    <option value="{{item.CoopCode}}">{{item.CoopCodeName}}</option>
  </ng-template>
</select>
